module.exports = __webpack_public_path__ + "static/media/outdent.c0de17cc.svg";